import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { IMaskInput } from 'react-imask';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';
// import isRegExp from 'lodash.isregexp';

import { Button } from '../../../../components';
import { getPractice, updatePractice } from './api';

// const PHONE_MASK = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export default class ProviderPractice extends React.Component {
	static propTypes = {
		user: PropTypes.object.isRequired,
		showNotification: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			practiceDefaultPrice: '0.00',
			practice_direct_address: '',
			invalidAddress: false,
			administrative_notification_number: '',
			invalidNumber: false,
			isSaving: false,
			chat_string: '',
		};
	}

	componentDidMount() {
		getPractice(this.props.user.provider_practice_id).then(({ data }) => {
			this.setState({
				providerPractice: data,
				practiceDefaultPrice: numeral(data.practiceDefaultPrice || 0).format(
					'0.00'
				),
				practice_direct_address: data.practice_direct_address || '',
				administrative_notification_number:
					data.administrative_notification_number,
				chat_string: data.chat_string || '',
			});
		});
	}

	handlePracticeDefaultPriceChange = ({ target }) => {
		this.setState({ practiceDefaultPrice: target.value });
	};

	handlePracticeDirectAddressChange = ({ target }) => {
		this.setState({
			practice_direct_address: target.value,
			invalidAddress: false,
		});
	};

	handleAdministrativeNotificationNumberChange = (
		value /* mask{ target }*/
	) => {
		this.setState({
			administrative_notification_number: value,
			invalidNumber: false,
		});
	};

	handleChatStringChange = ({ target }) => {
		this.setState({ chat_string: target.value });
	};

	handleSubmit = (event) => {
		event.preventDefault();
		this.setState({ isSaving: true });
		const {
			practiceDefaultPrice,
			practice_direct_address,
			administrative_notification_number,
			chat_string,
		} = this.state;
		let invalidAddress = false;
		let invalidNumber = false;
		let administrativeNotificationNumber = '';
		if (!isEmpty(practice_direct_address)) {
			invalidAddress = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
				practice_direct_address
			);
		}
		if (!isEmpty(administrative_notification_number)) {
			if (administrative_notification_number.length < 10) {
				invalidNumber = true;
				// } else {
				// 	invalidNumber = [...administrative_notification_number].reduce((prev, char, index) => {
				// 		let isCurrentCharInvalid = false;
				// 		if (isRegExp(PHONE_MASK[index])) {
				// 			isCurrentCharInvalid = !char.match(PHONE_MASK[index]);
				// 			administrativeNotificationNumber += char;
				// 		} else {
				// 			isCurrentCharInvalid = PHONE_MASK[index] !== char;
				// 		}
				// 		return prev || isCurrentCharInvalid; // true or false
				// 	}, invalidNumber);
			}
		}
		if (invalidAddress || invalidNumber) {
			this.setState({ invalidAddress, invalidNumber, isSaving: false });
			return;
		}

		updatePractice({
			...this.state.providerPractice,
			practiceDefaultPrice,
			practice_direct_address: isEmpty(practice_direct_address)
				? null
				: practice_direct_address,
			administrative_notification_number: isEmpty(
				administrativeNotificationNumber
			)
				? null
				: administrativeNotificationNumber,
			chat_string,
		})
			.then(() => {
				this.setState({ isSaving: false });
				this.props.showNotification({
					status: 'success',
					message: 'Practice updated successfully',
				});
			})
			.catch(() => {
				this.setState({ isSaving: false });
				this.props.showNotification({
					status: 'danger',
					message: 'Unable to update Practice',
				});
			});
	};

	render() {
		const {
			practiceDefaultPrice,
			practice_direct_address,
			administrative_notification_number,
			invalidAddress,
			invalidNumber,
			isSaving,
			chat_string,
			providerPractice = {},
		} = this.state;
		const practice_virtual_code = providerPractice.practice_virtual_code;
		const cc_merchant_id = providerPractice.cc_merchant_id;
		const practicName = providerPractice.practice_name;

		let formattedCode;
		if (practice_virtual_code) {
			formattedCode = `${practice_virtual_code.substring(
				0,
				3
			)}-${practice_virtual_code.substring(
				3,
				6
			)}-${practice_virtual_code.substring(6)}`;
		}

		const noMerchangeCode = isEmpty(cc_merchant_id);

		return (
			<div className="row provider-practic-form">
				<form
					className="col-md-8 col-md-offset-2 form-horizontal"
					onSubmit={this.handleSubmit}
				>
					<div className="panel panel-default">
						<div className="panel-body">
							<div className="form-group">
								<label className="col-lg-4 control-label">Practice Name</label>
								<div className="col-md-8">
									<p className="form-control-static">
										{practicName} / {providerPractice.id}
									</p>
								</div>
							</div>
							<div
								className={cn('form-group', { 'has-error': noMerchangeCode })}
							>
								<label
									htmlFor="practiceDefaultPrice"
									className="col-md-4 control-label"
								>
									Practice Visit Fee
								</label>
								<div className="col-md-8">
									<div className="input-group">
										<span className="input-group-addon">$</span>
										<input
											type="text"
											className="form-control"
											id="practiceDefaultPrice"
											value={practiceDefaultPrice}
											onChange={this.handlePracticeDefaultPriceChange}
											disabled={noMerchangeCode}
										/>
									</div>
									{noMerchangeCode && (
										<span className="help-block">
											<strong>No merchant code found!</strong>
											<br />
											Please contact Care Convene to help set this up. You will
											not be able to charge patients until this is complete.
										</span>
									)}
								</div>
							</div>
							<div
								className={cn('form-group', { 'has-error': invalidAddress })}
							>
								<label
									htmlFor="practice_direct_address"
									className="col-md-4 control-label"
								>
									Practice Direct Address
								</label>
								<div className="col-md-8">
									<input
										type="text"
										className="form-control"
										id="practice_direct_address"
										value={practice_direct_address}
										onChange={this.handlePracticeDirectAddressChange}
									/>
									{invalidAddress && (
										<span className="help-block">
											Please enter a valid email address
										</span>
									)}
								</div>
							</div>
							<div className={cn('form-group', { 'has-error': invalidNumber })}>
								<label
									htmlFor="administrative_notification_number"
									className="col-md-4 control-label"
								>
									Non-clinical Admin Notification Number
								</label>
								<div className="col-md-8">
									<IMaskInput
										mask="(000) 000-0000"
										className="form-control"
										id="administrative_notification_number"
										value={administrative_notification_number}
										onAccept={this.handleAdministrativeNotificationNumberChange}
										unmask
									/>
									{invalidNumber && (
										<span className="help-block">
											Please enter a valid notification number
										</span>
									)}
								</div>
							</div>
							{practice_virtual_code && (
								<div className="form-group">
									<label className="col-md-4 control-label">
										Practice Virtual Code
									</label>
									<div className="col-md-8">
										<pre>{formattedCode}</pre>
									</div>
								</div>
							)}
							<div className="form-group">
								<label className="col-md-4 control-label">
									Initial Practice Chat Message
								</label>
								<div className="col-md-8">
									<input
										type="text"
										className="form-control"
										id="chat_string"
										value={chat_string}
										onChange={this.handleChatStringChange}
										maxLength={2000}
									/>
									<span className="help-block">2000 characters max</span>
								</div>
							</div>
							<div className="form-group">
								<div className="col-md-offset-4 col-md-8">
									<Button primary title="Update Practice" disabled={isSaving} />
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		);
	}
}
